/**
 * Sport Logo Mapping
 *
 * Maps sport codes to their logo asset paths.
 * Used by admin list pages, frontend sport filters, etc.
 */

/** Map from uppercase sport code to logo path */
export const SPORT_LOGO_MAP: Record<string, string> = {
  // `league-icon.svg` is the NFL shield despite the generic filename — it is NOT a neutral
  // placeholder, and pointing a new sport at it silently badges that sport as the NFL.
  NFL: '/league-icon.svg',
  NBA: '/nba-logo.svg',
  // No WNBA mark in the asset set — the generic basketball icon, as NCAAMB uses.
  WNBA: '/basketball-logo.svg',
  NHL: '/nhl-logo.png',
  NCAAMB: '/basketball-logo.svg',
  NCAAFB: '/american-football-logo.svg',
  MLB: '/mlb-logo.svg',
  PGA: '/pga-logo.svg',
  MMA: '/mma-logo.svg',
  NASCAR: '/nascar-logo.svg',
  TENNIS: '/tennis-logo.svg',
  SOCCER: '/soccer-logo.svg',
  MIXED: '/dk-logo.svg',
};

/*
 * The fallback for an unmapped sport. Deliberately the DraftKings mark rather than
 * `league-icon.svg`: that file is the NFL shield, so the old default badged every unmapped sport
 * as the NFL — which is how MMA shipped showing an NFL logo in the pickem form. A house mark
 * reads as "no artwork yet"; another sport's badge reads as wrong information.
 */
const DEFAULT_LOGO = '/dk-logo.svg';

/**
 * Get the logo URL for a sport.
 * @param sport - Uppercase sport code (e.g. 'NFL', 'NBA'). Case-insensitive.
 * @returns Logo path string
 */
export function getSportLogoUrl(sport?: string): string {
  if (!sport) return DEFAULT_LOGO;
  return SPORT_LOGO_MAP[sport.toUpperCase()] || DEFAULT_LOGO;
}
